import LoginForm from './LoginForm/LoginForm.jsx';

export default function App() {

        return (
        <main>
            <LoginForm />
        </main>
    );
}
